import {$$} from '@vue-macros/reactivity-transform/macros'

import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {
  IDatabaseGroupItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IDatabaseGroupItemResponseInstance'
import {IReverseRelationPropertyTypeInterfaces} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/ReverseRelationPropertyTypeStrategy/types/IReverseRelationPropertyTypeInterfaces'

export function useReverseRelationPropertyTypeStrategy() {

  const getGroupFilter = (group: string, groupItem: IDatabaseGroupItemResponseInstance, _showAllDatabaseGroups: boolean): IFilter => {
    const rawRelationValue = (groupItem?.value ?? groupItem?.fullValue) as IReverseRelationPropertyTypeInterfaces['storedValue'] | string[] | null
    let firstItemId: string | null = null
    if(rawRelationValue && !Array.isArray(rawRelationValue)) {
      const firstItem = rawRelationValue?.firstItems?.[0] as {id?: string} | undefined
      firstItemId = firstItem?.id ? String(firstItem.id) : null
    } else if(Array.isArray(rawRelationValue)) {
      firstItemId = rawRelationValue.length ? String(rawRelationValue[0]) : null
    }
    if(!firstItemId) {
      return {
        type: FilterItemType.Property,
        id: group,
        operator: {
          type: FilterPropertyOperator.ArrayEmpty,
          options: {},
        },
        subProperty: 'firstItems',
        payload: {
          type: FilterPropertyPayloadType.Static,
          value: null,
        },
        isDisabled: false,
      }
    }
    return {
      type: FilterItemType.Property,
      id: group,
      operator: {
        type: FilterPropertyOperator.ArrayContains,
        options: {
          subProperty: 'id',
          isCaseSensitive: true,
        },
      },
      subProperty: 'firstItems',
      payload: {
        type: FilterPropertyPayloadType.Static,
        value: firstItemId,
      },
      isDisabled: false,
    }
  }

  return $$({
    getGroupFilter,
  })
}
